module.exports = "https://la-static.vkplay.ru/promo/universal/img/chest.6bb02138.png";